/* eslint-disable array-callback-return  */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import FormatGraphDataService from "components/year-review/services/FormatGraphDataService";

const YRTableMap = ({ name, data, style }) => {
  const { unit, country } = style;

  const [mapData, setMapData] = useState(null);

  useEffect(() => {
    const fetchMapData = async () => {
      const yearReviewContainer = document.querySelector("[data-year-review]");
      const { year } = yearReviewContainer.dataset;
      const { data } = await import(
        `components/year-review/assets/json/${year}/data-map-${country}.json`
      );

      setMapData(data);
    };

    fetchMapData();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="yr-table-container is-fixed-height">
      <table className="yr-table">
        <thead>
          <tr>
            <th />
            <th>{name}</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => {
            const itemName = item.name;
            let itemValue = "";

            if (mapData) {
              if (
                country === "world" &&
                typeof mapData[item.code] !== "undefined"
              ) {
                itemValue = mapData[item.code].valuePercentage;
              } else {
                itemValue = mapData[item.code];
              }
            }

            if (!itemValue) return;

            return (
              <tr key={`${index}-${itemName}-${itemValue}`}>
                <td>{itemName}</td>
                {itemValue && (
                  <td>
                    {FormatGraphDataService.addCommas(itemValue)}
                    {unit}
                  </td>
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

YRTableMap.defaultProps = {
  style: {},
};

YRTableMap.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(PropTypes.any).isRequired,
  style: PropTypes.objectOf(PropTypes.any),
};

export default YRTableMap;
